module.exports = __webpack_public_path__ + "static/media/img_report.3e19d057.png";